<script setup>
import AppSwiper from '#/general/AppSwiper.vue'
import { inject } from 'vue'
const { isBrowser } = inject('Shared')
const models = [
  {
    title: 'Partnermodell 1',
    subtitle: `
      Gemeinsame Entwicklung
      <br/>
      mit Gewinnbeteiligung
    `,
    subtitleMobile: `
      Entwicklung mit
      <br/>
      Gewinnbeteiligung
    `,

    body: `
        Wir Raumpioniere entwickeln Ihre Liegenschaft
        <strong>gemeinsam mit Ihnen. &#32;</strong>
        Dabei gehen wir in eine
        <strong>Vorleistung &#32;</strong>
        – das heisst, wir klären alle Möglichkeiten rund um die Entwicklung ab, treiben das Projekt bis zur rechtskräftigen Baubewilligung voran und setzen es dann als Totalunternehmer auch gleich für Sie um.
        <br/>
        <br/>
        Im Gegenzug räumen Sie uns Raumpionieren das Recht ein, am erzielten
        <strong>&#32; Mehrwert zu partizipieren.</strong>
    `
  },
  {
    title: 'Partnermodell 2',
    subtitle: `
      Verkauf der Liegenschaft
      <br/>
      mit Vorkaufsrecht
    `,
    subtitleMobile: `
    Kaufvertrag mit
    <br/>
    Vorrang
    `,
    body: `
      Sie verkaufen Ihre Liegenschaft zum
      <strong>&#32; geschätzten Verkehrswert</strong>
      an uns Raumpioniere. Wir entwickeln dann das Projekt, setzen es als Totalunternehmer um und vermarkten es auch gleich.
      <br />
      <br />
      Gleichzeitig räumen wir Raumpioniere Ihnen das
      <strong>&#32; Vorkaufsrecht &#32;</strong>
      (bei Stockwerkeigentum) ein, eine oder auch mehrere Wohnungen/Einheiten zu übernehmen, bevor Dritte zum Zug kommen.
    `
  }
]

const breakpoints = {
  320: {
    slidesPerView: 1.2,
    spaceBetween: 20
  },
  1024: {
    slidesPerView: 2,
    spaceBetween: 40
  }
}
</script>

<template lang="pug">
.solutions--models
  .routerPageSize
    app-swiper(:items="models" :breakpoints="breakpoints" v-if="isBrowser")
      template(#item="props")
        .solutions--model
          .solutions--model-svg(:class="`solutions--model-svg-${props.index}`")
            svg(width='225' height='249' viewBox='0 0 225 249' fill='none' xmlns='http://www.w3.org/2000/svg' v-if="props.index === 0")
              g(clip-path='url(#clip0_8146_44107)')
                path(d='M167.87 150.85L205.97 177.23L110.97 243L15.9702 177.23L54.0802 150.85V164.92L110.97 204.31L167.87 164.92V150.85Z' fill='#5FEFC0')
                path(d='M54.0802 139.98L15.9702 166.36L110.97 232.13L205.97 166.36L167.87 139.98' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M15.9702 166.36L110.97 232.13' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M2.26025 180.77L96.4403 245.97' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M3.70183 177.818L0.00244141 183.162L0.824685 183.731L4.52407 178.387L3.70183 177.818Z' fill='#22223C')
                path(d='M97.8835 243.017L94.1841 248.361L95.0063 248.93L98.7057 243.586L97.8835 243.017Z' fill='#22223C')
                path(d='M110.97 204.31L54.0801 164.92V117.65L110.97 157.04V204.31Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M110.97 157.04V204.31L167.87 164.92V117.65V86.1399L133.73 109.77V141.29L110.97 157.04Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M122.35 196.43V164.92L133.73 157.04V188.55L122.35 196.43Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M145.11 149.16V164.92L156.49 157.04V141.29L145.11 149.16Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M145.11 133.41V117.65L156.49 109.77V125.53L145.11 133.41Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M54.0801 117.65L76.8301 101.9L133.73 141.29L110.97 157.04L54.0801 117.65Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M76.8301 101.9V70.3899L133.73 109.77V141.29L76.8301 101.9Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M76.8301 70.39L110.97 46.75L167.87 86.14L133.73 109.77L76.8301 70.39Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M167.87 86.1399V40.3899L110.97 79.7799V157.04L133.73 141.29V109.77L167.87 86.1399Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M54.0801 117.65V40.3899L110.97 79.7799V157.04L54.0801 117.65Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M167.87 40.39L110.97 79.78L54.0801 40.39L110.97 1L167.87 40.39Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M34.1099 134V40.8899' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M37.3599 133.5H30.8599V134.5H37.3599V133.5Z' fill='#22223C')
                path(d='M37.3599 40.3899H30.8599V41.3899H37.3599V40.3899Z' fill='#22223C')
                path(d='M213.77 51.28L187.68 51.3L187.65 83.27L219.56 83.24L219.57 71.5' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M195.93 64.68L204.88 73.65L224.29 54.21' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M213.77 95.6299L187.68 95.6499L187.65 127.61L219.56 127.59L219.57 115.85' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M195.93 109.02L204.88 118L224.29 98.55' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_8146_44107
                  rect(width='225' height='248.92' fill='white')
            svg(width='211' height='243' viewBox='0 0 211 243' fill='none' xmlns='http://www.w3.org/2000/svg' v-else)
              g(clip-path='url(#clip0_7932_11643)')
                path(d='M96 242.94L191 177.17L96 111.4L1 177.17L96 242.94Z' fill='#5FEFC0')
                path(d='M198.79 51.72L172.71 51.74L172.68 83.7L204.59 83.68V71.93' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M180.95 65.1099L189.91 74.0899L209.32 54.6399' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M39.1 94.23L1 120.61L96 186.38L191 120.61L152.9 94.23' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96 186.38L191 120.61' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96 232.67L191 166.9L96 101.13L1 166.9L96 232.67Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96.0001 158.56L39.1001 119.17V71.8999L96.0001 111.29V158.56Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96 111.29V158.56L152.9 119.17V71.8999V40.3899L118.76 64.0199V95.5299L96 111.29Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M107.38 150.68V119.17L118.76 111.29V142.8L107.38 150.68Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M130.14 103.41V119.17L141.52 111.29V95.53L130.14 103.41Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M130.14 87.66V71.9L141.52 64.02V79.78L130.14 87.66Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M39.1001 71.8999L61.8601 56.1399L118.76 95.5299L96.0001 111.29L39.1001 71.8999Z' fill='white' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M61.8599 56.1399V24.6299L118.76 64.0199V95.5299L61.8599 56.1399Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M61.8599 24.63L95.9999 1L152.9 40.39L118.76 64.02L61.8599 24.63Z' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M39.1001 71.8999L61.8601 56.1399L118.76 95.5299L96.0001 111.29L39.1001 71.8999Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M61.8599 56.1399V24.6299L118.76 64.0199V95.5299L61.8599 56.1399Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(opacity='0.75' d='M61.8599 24.63L95.9999 1L152.9 40.39L118.76 64.02L61.8599 24.63Z' fill='#063CEF' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M191 120.61V166.9' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M1 120.48V166.78' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
                path(d='M96 186.38V232.57' stroke='#22223C' stroke-width='2' stroke-linejoin='round')
              defs
                clipPath#clip0_7932_11643
                  rect(width='210.02' height='242.94' fill='white')
          .solutions--model-box(:class="`solutions--model-box-${props.index}`")
            .solutions--model-title {{ props.item.title }}
            .solutions--model-subtitle(v-html="props.item.subtitle").gt-sm
            .solutions--model-subtitle(v-html="props.item.subtitleMobile").lt-md
            .solutions--model-body(v-html="props.item.body")
</template>

<style lang="sass">
.swiper-slide
  height: auto !important
  max-height: unset !important
.solutions--models
  @media screen and (min-width: 1024px)
    margin: -10px 0 87px
  @media screen and (max-width: 1024px)
    margin: -40px 0 70px
    .routerPageSize
      padding-top: 0px !important
      padding-bottom: 0px !important
      padding-right: 0px !important
  .solutions--model
    display: flex
    flex-direction: column
    align-items: center
    height: 100%
    .solutions--model-svg-0
      @media screen and (min-width: 1024px)
        margin-bottom: -110px
      @media screen and (max-width: 1024px)
        margin-bottom: -35px !important
        height: 210px
    .solutions--model-svg-1
      @media screen and (min-width: 1024px)
        margin-bottom: -105px
      @media screen and (max-width: 1024px)
        margin-bottom: -80px !important
        height: 210px
    .solutions--model-svg
      z-index: 1
    .solutions--model-box-1
      @media screen and (max-width: 1024px)
        margin-top: 45px
    .solutions--model-box
      background: #F6F7FA
      backdrop-filter: blur(5px)
      border-radius: 10px
      @media screen and (min-width: 1024px)
        padding: 150px 30px 33px
      @media screen and (max-width: 1024px)
        padding: 100px 25px 33px
        height: calc(100% - 200px)
    .solutions--model-title
      font-weight: 500
      line-height: 125%
      color: #1F47CD
      @media screen and (min-width: 1024px)
        font-size: 34px
      @media screen and (max-width: 1024px) and (min-width: 420px)
        font-size: 24px
      @media screen and (max-width: 420px)
        font-size: 24px
    .solutions--model-subtitle
      font-weight: 500
      line-height: 125%
      color: #2F3849
      margin-bottom: 20px
      @media screen and (min-width: 1024px)
        font-size: 34px
      @media screen and (max-width: 1024px) and (min-width: 420px)
        font-size: 24px
      @media screen and (max-width: 420px)
        font-size: 24px
    .solutions--model-body
      font-weight: 400
      line-height: 150%
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 20px
      @media screen and (max-width: 1024px)
        font-size: 16px
</style>
